import React from 'react';
import styled from 'styled-components';

import { token } from '@/theme';

const Chip = ({ title, ...rest }: {
  title: string,
  className: string,
  onClick?: () => void,
}) => {
  return <Container {...rest}>{title}</Container>;
};

const Container = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${token.paddingXXS}px ${token.paddingXS}px;
  border-radius: 13.5px;
  background-color: ${token.colorPrimary};
  font-size: ${token.fontSize}px;
  color: ${token.colorText};
  min-width: 100px;
`;

export default Chip;
